var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"float",attrs:{"href":_vm.numero,"target":"_blank"}},[_c('ion-icon',{staticClass:"my-float",attrs:{"name":"logo-whatsapp","size":"large"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }